import { render, staticRenderFns } from "./RightSideMenu.vue?vue&type=template&id=2ea1e981&scoped=true&"
import script from "./RightSideMenu.vue?vue&type=script&lang=js&"
export * from "./RightSideMenu.vue?vue&type=script&lang=js&"
import style0 from "./RightSideMenu.vue?vue&type=style&index=0&id=2ea1e981&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea1e981",
  null
  
)

export default component.exports